import API from '../apiCreate'

export type SendEmailCodeRequest = {
  user_id: number
  email: string
}

export type VerifyEmailCodeRequest = {
  user_id: number
  code: string
}

export const emailConfirmation = {
  sendEmailCode: (data: SendEmailCodeRequest) =>
    API.post(`verification/send-email-code`, data),
  verifyEmailCode: (data: VerifyEmailCodeRequest) =>
    API.post(`verification/verify-email-code`, data),
  getEmailStatus: (userId: number | string) =>
    API.get(
      `verification/get-email-status?user_id=${encodeURIComponent(String(userId))}`,
    ),
}
